import { Grid, Box, ButtonGroup, Table, TableBody } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { WhiteCard } from 'components/styles_components/card';
import { CardOptionTypography, CardTitleTypography } from 'components/styles_components/typography';
import EditButton from 'components/template/button/edit';
import DeleteButton from 'components/template/button/delete';
import ShowItemTableRow from 'components/item/show_item_table_row';
import InspectionFieldsListIndex from 'components/inspection_field/index';
import InfoContainer from 'components/info_container';

const ShowItem = ({ template, space, refetch }) => {
  return (
    <WhiteCard>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <CardTitleTypography variant="h5">{template.name}</CardTitleTypography>
          <Table>
            <TableBody>
              <ShowItemTableRow label={<FormattedMessage id="inspection.period" />}>
                {template.periodCycle && template.periodNumber && (
                  <FormattedMessage
                    id={`inspection.period.${template.periodCycle}.count`}
                    values={{ count: template.periodNumber }}
                  />
                )}
              </ShowItemTableRow>
              <ShowItemTableRow
                label={<FormattedMessage id="inspection.count" />}
                emptyComponent="0"
              >
                {template.inspectionsTotal}
              </ShowItemTableRow>
              <ShowItemTableRow
                label={<FormattedMessage id="inspection.field.count" />}
                emptyComponent="0"
              >
                {template.templateFields.length}
              </ShowItemTableRow>
            </TableBody>
          </Table>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <CardOptionTypography>
            <FormattedMessage id="inspection.field.count" />
          </CardOptionTypography>
          {template.templateFields.length > 0 ? (
            <Table>
              <TableBody>
                <InspectionFieldsListIndex
                  showValues={false}
                  inspectionFields={template.templateFields}
                />
              </TableBody>
            </Table>
          ) : (
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <InfoContainer>
                <FormattedMessage id="inspection.fields.empty" />
              </InfoContainer>
            </Box>
          )}
        </Grid>
      </Grid>
      {space.adminRole && (
        <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
          <ButtonGroup variant="contained">
            <EditButton template={template} space={space} refetch={refetch} />
            <DeleteButton template={template} space={space} />
          </ButtonGroup>
        </Box>
      )}
    </WhiteCard>
  );
};

export default ShowItem;
